import React,{useEffect,useContext,useState,useRef} from 'react'
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import { Box,Tooltip,IconButton,FormControl, Radio, RadioGroup,
  FormControlLabel, Typography, Card, Checkbox,  
  InputLabel, Select} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import { Bar, Doughnut} from 'react-chartjs-2';
import Reporte from './Reporte'
import ReporteSN from './ReporteSNDatos'
import moment from 'moment';
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
import Reloj from './Reloj';
import LinearProgress from '@material-ui/core/LinearProgress';
import DateFnsUtils from '@date-io/date-fns'; // choose your lib
import esLocale from "date-fns/locale/es";
import { DatePicker,MuiPickersUtilsProvider} from '@material-ui/pickers';
import {findNumber} from '../funciones/FindNumber'
import {llamadaApiToken,ErrorGeneral , llamaApiCargaToken } from '../funciones/ClienteAxios';
import Disponib from '../Disponi'
import TablaBitacora from '../Bitacora-Reporte/TablaBitacora'
import TablaEfectividad from '../Bitacora-Reporte/TablaEfectividad';
import SearchIcon from '@material-ui/icons/Search';
import NumberFormat from 'react-number-format';
const useStyles = makeStyles((theme)=>({

  title: {
    fontSize: 30,
    fontWeight:650,
  },
  title2: {
      fontSize: 22,
      fontWeight:650,
    },
  title4: {
  fontSize: 18,
  fontWeight:650,
  },
  title3: {
  fontSize: 16,
  fontWeight:650,
  },
  
 
  
}));

const Relojes2 = ({fechas,setFechas,opcionBit}) => {    
  const {inicio,final}=fechas  
  const guardarInicio = auxF =>
  {
    setFechas({...fechas, inicio : auxF })
  };  
  
  const guardarFinal = auxF =>
  {
    setFechas({...fechas, final : auxF })
  };

  return (
  <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>  
  <Box display={"flex"} flexDirection={"column"}> 
    <Box component="span"  >
      <Tooltip title="Seleccionar Fecha" >                
        <DatePicker
          disableFuture   format="dd/MM/yyyy"
          views={["year", "month", "date"]}
          label="Fecha" size="small"
          minDate="2023-03-31" maxDate={new Date()}
          value={inicio} onChange={guardarInicio}            
          style={{width:7+'rem'}} cancelLabel={"Cancelar"}                  
          okLabel="Seleccionar" 
        />                           
      </Tooltip>                                   
    </Box>  
   {opcionBit!=="dia"?
    <Box   component="span" width="25%">
      <DatePicker
        disableFuture id="final"
        format="dd/MM/yyyy" label="Fecha Final"
        views={["year", "month", "date"]}
        minDate={inicio} maxDate={new Date()}
        value={final} name="final"
        size="small" style={{width:6.5+'rem'}}      
        cancelLabel={"Cancelar"} okLabel="Seleccionar"    
        onChange={guardarFinal}
        minDateMessage={"La fecha final debe ser menor a Fecha inicial"}
      />
    </Box>
    :null}                  
    </Box> 
  </MuiPickersUtilsProvider>
  );
}

 
const colores=["#5DE163","#FFC400","#24392D","#018786","#03DAC5","#E91E63"]
const camposListas=[ 'Total Usuarios', 'Usuarios', '3Edad', 'Discapacidad', 'Niños','Otros',  ]

const RepoUsuario = () => {
  const usu= localStorage.getItem('UsuarioNom');
  const nvl= localStorage.getItem('Tipo');    
  const usuID= localStorage.getItem('UsuId'); 
  const history = useHistory();
  const classes = useStyles(); 
  const [arrGrafica1, setArrGrafica1] = useState([])  
  const [checkDetalle, setCheckDetalle] = useState(false)            
  const source = axios.CancelToken.source();  
  const [datos,setDatos]=useState([])
  const [listDet,setListDet]=useState([])
  const [listEstacion,setListEstacion]=useState([])
  const [listTerminal, setListTerminal]=useState([])
  const [espera,setEspera]=useState(false)
  const [espera2,setEspera2]=useState(false)
  const [espera3,setEspera3]=useState(false)
  const {usuario,guardarUsuario}=useContext(AuthContext);
  const {guardarGenerales}=useContext(GeneralesContext);  
  const [listDispo,setListDispo]=useState([])  
  const [buscar,setBuscar]=useState(false)
  const [filtro, setFiltro]=useState({Terminal:0, Estacion:0})
  const [fechas,setFechas]=useState({inicio:new Date(),final:new Date()})
  const [opcionBit, setOpcionBit] = useState('rango');
  const opcionRef = useRef('dia');
  const {Terminal,Estacion}=filtro
  const {inicio,final}=fechas
  
  useEffect(()=>{               
   
    veriSesion()
    datosBitacora()    
    if (listTerminal.length === 0) {
      getListTerminal()
    }
    return ()=> {
      source.cancel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps	
  },[buscar]) 

  useEffect(()=>{               
   
    if (Terminal !==0) {
      llenarUbicaciones()
    }
    
  },[Terminal])

  const getListTerminal = () => {
    const data = qs.stringify({
        usuario: usuID, idDispositivo: '89y7gttvjhj98h'
    });
    const url = "/lugar-terminal-list";

    function respuesta(aux) {
      if (aux[0].Id !== -1) {
        let auxArre = [];
        aux.forEach((tipo) => {
          if (tipo.Id != 0) {
            auxArre.push({value: tipo.Id, label: tipo.Descr})
          }
        })
        setListTerminal(auxArre);
      }
    }

      llamadaApiToken(data, url, respuesta, ErrorGeneral, history, source)
  };

  function llenarUbicaciones() {
    const auxUbi = JSON.parse(localStorage.getItem('LisUbicOrd'));

    let auxArre = [];    
    
    const auxFiltro= auxUbi.filter((ubica)=>ubica.LugarId.toString() === "1" && ubica.Terminal.search(Terminal) !== -1)
    auxUbi.forEach((ubica) => {
      if (ubica.LugarId.toString() === "1" && (ubica.Terminal.search(Terminal) !== -1)) {
        auxArre.push({value: ubica.Id, label: ubica.Tipo})          
      }
    })
     
    setListEstacion(auxArre)
   
  }

  const veriSesion =  () => 
  {            
    if(usu===null)
    {                                
      guardarUsuario([])						
      guardarGenerales([])     
      localStorage.clear();           
      history.push("/")	
    }
    else
    { 
      if (usuario.length === 0) 
      {
        guardarUsuario({Nombre:usu,nivel:nvl});                                      
      }
      guardarGenerales({Titulo:'Reporte Usuarios'})                     
    }
  }
 
  
  const datosBitacora=()=>{
     
    const fInicio=moment(inicio).format("YYYY-MM-DD")   
    const fFin=moment(final).format("YYYY-MM-DD")                
    const data = qs.stringify({    
      Usuario:usuID,
      Terminal:Terminal,
      Estacion:Estacion,
      IsUsrExento:1,
      fechaIni:fInicio+'T00:00:00' ,
      fechaFin:(opcionBit==='dia'?fInicio: fFin)+'T23:59:59',                                  
      idDispositivo:'ifrekvjkxcdwdcwe'
    });
    const url =  "/reporte/bitacora/usuario/intervalo";
    function respuesta(aux) {
      if (aux[0].length!==0) 
      {                
        setDatos(aux[0]);                                      
       
      }          
    }

    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);
  }
  
 
 
  function verificaReporte(auxJson){
    let auxValido=false;
    if (auxJson?.terminal !== undefined && auxJson.terminal[0].paros) {
      auxValido=true;
    //console.log('no esta vacio');
    } 
    else 
    {
      auxValido=false;
      //console.log('si esta vacio');
    }
    return auxValido;
  }

  const onChange = e => {
    setFiltro({
      ...filtro,
      [e.target.name]: e.target.value
    })
  };

  const incrementarBuscar = e =>
  { // e.preventDefault();    
      
    setBuscar(!buscar)        
      
  };//Reporte-BitacoraIntervalo260415

 
  const datosUsu=(datos)=>{    
    
    return(
    <Box mb={1} mt={1}>   
      <Card>
    <Box display={"flex"} flexDirection={"row"}>
      <Box mx={1} mt={1} width={"33%"}>
        <Typography className={classes.title4}  variant="h5" component="h2" 
          align="center"  color={'secondary'}> 
          <NumberFormat value= {datos.UsrCobro + datos.ExeEdad + datos.ExeDiscapa + datos.ExeNinos + datos.ExeOtros} displayType={'text'}  
            thousandSeparator={true}/>    
        </Typography>                                    
        <Typography color="textSecondary" style={{fontSize:.95+'rem'}} align="center">
          Total Usuarios
        </Typography>
      </Box>     
      <Box mx={1} mt={1} width={"33%"} >
        <Typography className={classes.title4}  variant="h5" component="h2" 
          align="center"  color={'secondary'}> 
          <NumberFormat value= {datos.UsrCobro} displayType={'text'}  
            thousandSeparator={true}/>    
        </Typography>                                    
        <Typography color="textSecondary" style={{fontSize:.95+'rem'}} align="center">
            Usuarios
        </Typography>
      </Box>    
      <Box mx={1} mt={1} width={"33%"} >
        <Typography className={classes.title4}  variant="h5" component="h2" 
          align="center"  color={'secondary'}> 
          <NumberFormat value= {datos.ExeEdad  } displayType={'text'}  
            thousandSeparator={true}/>    
        </Typography>                                    
        <Typography color="textSecondary" style={{fontSize:.95+'rem'}} align="center">
          3edad
        </Typography>
      </Box>   
    </Box>
    <Box display={"flex"} flexDirection={"row"} mb={1}>
        
      <Box mx={1} mt={1}  width={"33%"} >
        <Typography className={classes.title4}  variant="h5" component="h2" 
          align="center"  color={'secondary'}> 
          <NumberFormat value= {datos.ExeDiscapa } displayType={'text'}  
            thousandSeparator={true}/>    
        </Typography>                                    
        <Typography color="textSecondary" style={{fontSize:.95+'rem'}} align="center">
            Discapacidad
        </Typography>
      </Box> 
      <Box mx={1} mt={1}  width={"33%"} >
        <Typography className={classes.title4}  variant="h5" component="h2" 
          align="center"  color={'secondary'}> 
          <NumberFormat value= {datos.ExeNinos  } displayType={'text'}  
            thousandSeparator={true}/>    
        </Typography>                                    
        <Typography color="textSecondary" style={{fontSize:.95+'rem'}} align="center">
          Niños
        </Typography>
      </Box>     
      <Box mx={1} mt={1}  width={"33%"} >
        <Typography className={classes.title4}  variant="h5" component="h2" 
          align="center"  color={'secondary'}> 
          <NumberFormat value= {datos.ExeOtros } displayType={'text'}  
            thousandSeparator={true}/>    
        </Typography>                                    
        <Typography color="textSecondary" style={{fontSize:.95+'rem'}} align="center">
          Otros
        </Typography>
      </Box>         
    </Box>
    </Card> 
 
    </Box>
    ) 
  }
  
  const cambioDetalle = (event) => {
    setCheckDetalle( event.target.checked );
  };


  const urlReport=opcionBit==='dia'?"reports/BitacoraReport260415.mrt":"reports/Reporte-BitacoraIntervalo260415.mrt"
  return (
  <Box display="flex" flexDirection="row" >
    <Box display="flex" width="22rem" flexDirection="column" id='caja0'>
      <Box id="caja1" display="flex" flexDirection="row">
        {listTerminal.length !== 0 ? 
          <FormControl size="small" style={{width:"5.2rem"}}>
            <InputLabel htmlFor="age-native-simple">Terminal</InputLabel>
            <Select native
              value={Terminal} onChange={onChange}
              inputProps={{ name: 'Terminal', id: 'Terminal',}}
            >
              <option aria-label="None" value=""/>
              {listTerminal.map((row) => (
                <option value={row.value}>{row.label}</option>
              ))}
            </Select>
          </FormControl>
        : null}
     
        {listEstacion.length !== 0 ? 
          <FormControl size="small" style={{width:"5.2rem", marginLeft:"1rem"}}>
            <InputLabel htmlFor="age-native-simple">Estación</InputLabel>
            <Select native
              value={Estacion} onChange={onChange}
              inputProps={{ name: 'Estacion', id: 'Estacion',}}
            >
              <option aria-label="None" value=""/>
              {listEstacion.map((row) => (
                <option value={row.value}>{row.label}</option>
              ))}
            </Select>
          </FormControl>
        : null}
      </Box>
      <Box display="flex" id="caja2"  flexDirection="row" mb={1} >        
        <Relojes2 fechas={fechas} setFechas ={setFechas } opcionBit={opcionBit} />
        <Box style={{ marginLeft:".5rem"}} display="flex" justifyContent="center">    
          <Tooltip title="Buscar reporte" >                          
            <IconButton color="inherit"  aria-label="add circle" 
              component="span" onClick={incrementarBuscar} 
            >
              <SearchIcon color="primary" style={{ fontSize: 40 }}  />
            </IconButton>            
          </Tooltip>  
        </Box>    
      </Box>
   
      
      {/* opcionBit === 'rango' && listDet.length!==0  &&listDispo.length!==0?
        datosUsu(listDet)
      :null */}                    
    </Box>
    <Box display="flex"   >
      {opcionBit==="dia"||( checkDetalle && opcionBit==="rango") ?
      ( !espera ? 
        ( datos.length !== 0 ?  
          ( verificaReporte(datos) ?
            <Reporte urlReport={urlReport} informacion={datos}
              nombre={' Reporte Bitacora'} mostrarTB={findNumber('|54|')?true:false  }
            />
            : 
            <ReporteSN urlReport={urlReport} informacion={datos}
              nombre={' Reporte Bitacora'} mostrarTB={findNumber('|54|')?true:false }
            /> 
            
          ) 
          : 
          <Reporte urlReport={urlReport} informacion={datos}
            nombre={' Reporte Bitacora'} mostrarTB={findNumber('|54|')?true:false }
          />
        )
        :
        <Box style={{width:'100%'}} pt={2}> <LinearProgress color="primary" /></Box>
      )
      : null
      }                
    </Box>
  </Box>                          
  )
}

export default RepoUsuario